import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import lozad from 'lozad';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LazyLoadImageService {
  isBrowser;
  constructor(@Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
  }

  lazyLoad(options = {}) {
    const opt = {
      selector: '.lozad',
      wrapperSelector: '.picture-wrapper',
      classToRemove: 'background-gray',
      ...options,
    };

    if (this.isBrowser) {
      setTimeout(() => {
        const observer = lozad(opt.selector, {
          load: el => {
            el.src = el.dataset.src;
          },
          loaded: el => {
            el.classList.remove('v-none');
            if (el.closest(opt.wrapperSelector)) {
              el.closest(opt.wrapperSelector).classList.remove(opt.classToRemove);
            }
          },
        });
        observer.observe();
      }, 10);
    }
  }
}
